export const DEVICES = "devices";
export const CHAPTERS = "chapters";
